import * as Sentry from "@sentry/nextjs";

export const SENTRY_EVENT_TAG = "request_error";

/**
 * @param value string 接口名称或者事件名称
 */
export const setEventTag = (value: string) => {
	Sentry.configureScope((scope) => {
		scope.setTag(SENTRY_EVENT_TAG, value);
	});
	Sentry.setTag(SENTRY_EVENT_TAG, value);
};
export interface SentryCatchRequestParam {
	request: string;
	error: string;
}

export const setSentryCatchOnRequest = ({ request, error }: SentryCatchRequestParam) => {
	setEventTag(request);
	Sentry.captureException(error);
};
